<template>
  <PublicPopup ref="PopupRef" type="fullScreen" @close="emit('close')">
    <template #content>
      <div class="popup-container chxy-column-c-c">
        <div class="popup-box">
          <div class="popup-bg">
            <img
              class="sign-in-popup-header-img"
              :src="getImageUrlWithCDN_TEST('/ad-popup/sign-in-popup-header.png', 'local')"
            />
            <div class="title">{{ $t('home-ad-popup-sign-in-popup.title') }}</div>
          </div>
          <div class="popup-content">
            <div class="header-container chxy-row-bt">
              <div class="cell-item">
                <div class="label-box">
                  <span>{{ $t('home-ad-popup-sign-in-popup.consecutiveCheckIns') }}</span>
                  <br />
                  <span>{{ $t('home-ad-popup-sign-in-popup.days') }}</span>
                </div>
                <div class="value-box"><span>0</span></div>
              </div>
              <div class="cell-item">
                <div class="label-box">
                  <span>{{ $t('home-ad-popup-sign-in-popup.redeemed') }}</span>
                </div>
                <div class="value-box amount"><span>0,00</span></div>
                <div :class="['refresh-icon', { rotating: isRefreshing }]" @click="handleRefresh">
                  <SvgIcon
                    name="public-info_balance_refresh_style-2"
                    fill="var(--public-info_balance_refresh_style-2-theme)"
                    :size="14.5"
                  />
                </div>
              </div>
            </div>
            <div class="bodyer-container">
              <div class="sign-in-list">
                <div
                  v-for="(e, i) in signInlist"
                  :key="e.id"
                  :class="['sign-in-item', { 'can-receive': e.status === 1 }]"
                >
                  <div class="dot-box">{{ i + 1 }}</div>
                  <div class="icon-box">
                    <img
                      class="icon-img"
                      :src="getImageUrlWithCDN_TEST('/ad-popup/us-dollars-icon.png', 'local')"
                    />
                  </div>
                  <div class="content-box">
                    <span class="label">
                      {{ $t('home-ad-popup-sign-in-popup.dayReward', { day: i + 1 }) }}
                    </span>
                    <span class="value">{{ $t('home-ad-popup-sign-in-popup.bonus') }}</span>
                  </div>
                  <div class="button-box">
                    <button :class="['buttons', { 'can-receive': e.status === 1 }]">
                      {{
                        e.status === 1
                          ? $t('home-ad-popup-sign-in-popup.enter')
                          : $t('home-ad-popup-sign-in-popup.dayBtn', { day: i + 1 })
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="public-introduction">
                <div class="introduction-item">
                  <div class="introduction-title">
                    <div class="title-container">
                      <span class="title-text">
                        {{ $t('home-ad-popup-sign-in-popup.activityDescTitle') }}
                      </span>
                      <i class="arrow-left"></i>
                    </div>
                  </div>
                  <div class="content-box">
                    {{ $t('home-ad-popup-sign-in-popup.activityDesc') }}
                  </div>
                </div>
                <div class="introduction-item">
                  <div class="introduction-title">
                    <div class="title-container">
                      <span class="title-text">
                        {{ $t('home-ad-popup-sign-in-popup.termsTitle') }}
                      </span>
                      <i class="arrow-left"></i>
                    </div>
                  </div>
                  <div class="content-box">{{ $t('home-ad-popup-sign-in-popup.terms') }}</div>
                </div>
              </div>
            </div>
            <div class="footer-container">
              <div class="cell-container chxy-row-bt">
                <div class="cell-item">
                  <div class="label-box">
                    <span>{{ $t('home-ad-popup-sign-in-popup.depositedAmount') }}</span>
                  </div>
                  <div class="value-box">
                    <span class="red">0</span>
                    <span>/30</span>
                  </div>
                </div>
                <div class="cell-item">
                  <div class="label-box">
                    <span>{{ $t('home-ad-popup-sign-in-popup.depositedAmount') }}</span>
                  </div>
                  <div class="value-box">
                    <span class="red">0</span>
                    <span>/500</span>
                  </div>
                </div>
              </div>
              <div class="checkbox-content chxy-row-bt">
                <div class="checkbox-container">
                  <input
                    v-model="checked"
                    class="checkbox"
                    type="checkbox"
                    :checked="localChecked === 'checked'"
                    @change="change"
                  />
                  <span class="text">{{ $t('home-ad-popup-sign-in-popup.dontShowToday') }}</span>
                </div>
                <div class="checkbox-container">
                  <input
                    v-model="checked"
                    class="checkbox"
                    type="checkbox"
                    :checked="localChecked === 'checked'"
                    @change="change"
                  />
                  <span class="text">{{ $t('home-ad-popup-sign-in-popup.hidePermanently') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="close-container chxy-row-c-c" @click="handlePopupClose">
          <van-icon name="close" size="32" color="#FFFFFF" />
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { successToast } from '@/utils/toast'

const { t } = useI18n()

const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const isRefreshing = ref(false)
const handleRefresh = async () => {
  if (isRefreshing.value) return

  isRefreshing.value = true

  setTimeout(() => {
    successToast(t('home-ad-popup-sign-in-popup.refreshSuccess'))
    isRefreshing.value = false
  }, 480)
}

const signInlist = ref([
  { id: 1, status: 1 },
  { id: 2, status: 0 },
  { id: 3, status: 0 },
  { id: 4, status: 0 },
  { id: 5, status: 0 },
  { id: 6, status: 0 },
  { id: 7, status: 0 },
])

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.popup-container {
  position: relative;
  margin: 0 auto;
  width: calc(100% - 20px);
  height: 100%;

  .popup-box {
    position: relative;
    width: 100%;
    height: 80%;

    .popup-bg {
      position: absolute;
      z-index: -1;
      width: 100%;
      height: 100%;

      &::before,
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: '';
        background: #29764b;
        border-radius: 10px;
      }

      &::before {
        width: 70%;
        height: 100%;
      }
      &::after {
        width: 100%;
        height: 95%;
      }

      .title {
        position: absolute;
        left: 15px;
        top: 10px;
        z-index: 1;
        font-size: 15px;
        font-weight: 700;
        color: #ffffff;
      }
      .sign-in-popup-header-img {
        position: absolute;
        right: 0;
        top: -26px;
        z-index: 1;
        width: 255px;
        height: 72px;
      }
    }

    .popup-content {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      width: calc(100% - 20px);
      height: calc(100% - 55px);
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;

      .header-container,
      .cell-container {
        padding: 10px;
        background: #ffffff;

        .cell-item {
          display: flex;
          gap: 5px;
          height: 28px;

          .label-box {
            font-size: 12px;
            color: #999999;
            line-height: 1.2;
          }

          .value-box {
            font-size: 12px;
            color: #333333;
            line-height: 1.2;

            &.amount {
              color: #ffaa09;
              text-decoration: underline;
              text-underline-offset: 2px;
            }
            .red {
              color: #ea4e3d;
            }
          }

          .refresh-icon {
            margin-top: 2px;
            margin-left: 4px;
            width: fit-content;
            height: fit-content;

            &.rotating {
              animation: rotateThreeTimes 480ms linear forwards;
            }

            @keyframes rotateThreeTimes {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          }
        }
      }

      .bodyer-container {
        padding: 10px;
        height: calc(100% - 52px - 64px);
        overflow-y: auto;

        .sign-in-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding-left: 24px;

          .sign-in-item {
            position: relative;
            display: flex;
            align-items: center;
            padding: 5px 10px;
            background: #f5f5f5;
            border-radius: 7px;
            box-shadow: 0 1.5px 3.5px 0 #0000001f;

            &:nth-last-of-type(1) {
              .dot-box {
                &::after {
                  display: none;
                }
              }
            }

            &.can-receive {
              .dot-box {
                background: #26744a;

                &::after {
                  background: #26744a;
                }
              }
            }

            .dot-box {
              position: absolute;
              left: -24px;
              top: 50%;
              transform: translateY(-50%);
              display: flex;
              justify-content: center;
              align-items: center;
              width: 18px;
              height: 18px;
              background: #cccccc;
              border-radius: 50%;
              font-size: 12px;
              color: #ffffff;

              &::after {
                position: absolute;
                left: 50%;
                bottom: -50px;
                transform: translateX(-50%);
                content: '';
                width: 2px;
                height: 50px;
                background: #cccccc;
              }
            }

            .icon-box {
              margin-right: 10px;
              width: 36px;
              height: 36px;
              background: #b6cec1;
              border-radius: 50%;

              .icon-img {
                width: 36px;
                height: 36px;
              }
            }

            .content-box {
              display: flex;
              flex-direction: column;
              gap: 5px;
              width: calc(100% - 10px - 36px - 72px);

              .label {
                font-size: 12px;
                color: #999999;
                line-height: 1;
              }

              .value {
                font-size: 11px;
                color: #ffaa09;
              }
            }

            .button-box {
              width: 72px;
              height: 100%;

              .buttons {
                width: 72px;
                height: 26px;
                border: 1px solid #cecece;
                border-radius: 50px;
                font-size: 11px;
                color: #999999;

                &.can-receive {
                  background: #04be02;
                  border-color: #04be02;
                  color: #ffffff;
                }
              }
            }
          }
        }

        .public-introduction {
          margin-top: 10px;
          padding: 10px;
          color: #666666;
          font-size: 14px;
          line-height: 1.5;
          white-space: pre-wrap;
          word-break: break-word;
          background-color: #f5f5f5;
          border-radius: 7px;
          box-shadow: 0 1.5px 3.5px 0 #0000001f;

          .introduction-item + .introduction-item {
            margin-top: 10px;
          }
          .introduction-item {
            .introduction-title {
              .title-container {
                position: relative;
                display: inline-block;
                left: -14px;
                height: 32px;
                margin-bottom: 10px;
                max-width: 100%;

                &::before {
                  content: '';
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 4px;
                  height: 5px;
                  background-color: #26744a;
                  border-bottom-left-radius: 3px;
                }
                &::after {
                  content: '';
                  position: absolute;
                  top: 12px;
                  right: -14px;
                  width: 4px;
                  height: 4px;
                  background-color: #26744a;
                  border-radius: 50%;
                  z-index: 1;
                }

                .title-text {
                  position: relative;
                  display: inline-block;
                  max-width: 100%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  padding-left: 14px;
                  padding-right: 5px;
                  font-size: 16px;
                  height: 29px;
                  line-height: 29px;
                  color: #ffffff;
                  background-color: #26744a;
                  border-top-left-radius: 3px;
                  z-index: 1;
                }

                .arrow-left {
                  position: absolute;
                  top: 0;
                  right: -13px;
                  width: 14px;
                  height: 29px;
                  overflow: hidden;
                  z-index: 0;

                  &::after {
                    content: '';
                    position: absolute;
                    top: -2px;
                    left: 0;
                    border: 16px solid transparent;
                    border-left-color: #26744a;
                  }
                }
              }
            }
          }
        }
      }

      .footer-container {
        background: #ffffff;

        .cell-container {
          .cell-item {
            height: 14px;
          }
        }

        .checkbox-content {
          .checkbox-container {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 0 10px;
            border-radius: 5px;

            .checkbox {
              width: 16px;
              height: 16px;
              border: 1px solid #cecece;
              border-radius: 2px;
              appearance: none;
              -webkit-appearance: none;
              -moz-appearance: none;
              background: #f5f5f5;
            }
            .checkbox:checked {
              appearance: auto;
              -webkit-appearance: auto;
              -moz-appearance: auto;
            }

            .text {
              width: calc(100% - 21px);
              font-size: 11px;
              color: #666666;
              line-height: 1.1;
            }
          }
        }
      }
    }
  }

  .close-container {
    margin-top: 15px;
  }
}
</style>
